import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiException, ForgotPasswordRequest, HttpValidationProblemDetails, IdentityClient } from '../../api_identity/api';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  submitted = false;
  submitting = false;
  errorMessages: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private identityClient: IdentityClient
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (!this.forgotPasswordForm.valid || this.submitting) {
      return;
    }

    this.submitting = true;
    this.errorMessages = [];
    const email = this.forgotPasswordForm.get('email')?.value;

    const request = new ForgotPasswordRequest({ Email: email });
    this.identityClient.forgotPassword(request).subscribe({
      next: () => {
        this.submitted = true;
        this.submitting = false;
      },
      error: (err) => {
        this.submitting = false;

        if (err instanceof HttpValidationProblemDetails && err.errors) {
          this.errorMessages = Object.values(err.errors).flat();
        } else if (ApiException.isApiException(err) && err.status === 429) {
          this.errorMessages = ['Too many requests. Please wait a few minutes before trying again.'];
        } else {
          this.errorMessages = ['Something went wrong. Please try again later.'];
        }
      }
    });
  }
}
